/**
 * Канонический UUID системной компании (ИП владельца площадки, vde76).
 * Совпадает с SYSTEM_COMPANY_UUID в backend/.env — не определять по имени компании.
 */
const DEFAULT_SYSTEM_COMPANY_UUID = '10000000-0000-4000-8000-000000000002';

/**
 * Канонический UUID платформенной административной компании «ООО МАРКБЭЙС».
 * Совпадает с PLATFORM_ADMIN_COMPANY_UUID в backend/.env.
 */
const DEFAULT_PLATFORM_ADMIN_COMPANY_UUID = '10000000-0000-4000-8000-000000000003';

export const SYSTEM_COMPANY_UUID = String(
  process.env.REACT_APP_SYSTEM_COMPANY_UUID || DEFAULT_SYSTEM_COMPANY_UUID
).trim();

export const PLATFORM_ADMIN_COMPANY_UUID = String(
  process.env.REACT_APP_PLATFORM_ADMIN_COMPANY_UUID || DEFAULT_PLATFORM_ADMIN_COMPANY_UUID
).trim();

export function isSystemCompanyId(companyId) {
  if (!companyId) return false;
  return String(companyId).toLowerCase() === SYSTEM_COMPANY_UUID.toLowerCase();
}

export function isPlatformAdminCompanyId(companyId) {
  if (!companyId) return false;
  return String(companyId).toLowerCase() === PLATFORM_ADMIN_COMPANY_UUID.toLowerCase();
}

/** Любая из двух системных компаний (ИП `…0002` или ООО `…0003`). */
export function isProtectedSystemCompanyId(companyId) {
  return isSystemCompanyId(companyId) || isPlatformAdminCompanyId(companyId);
}

/** Подпись контекста для switcher: ООО — управление платформой, ИП — торговля. */
export function getSystemCompanyContextLabel(companyId) {
  if (isPlatformAdminCompanyId(companyId)) return 'Платформа';
  if (isSystemCompanyId(companyId)) return 'Коммерция';
  return null;
}
